// extracted by mini-css-extract-plugin
export default {"img-m":"Footer_img-m__Fg0iA","h-w-45":"Footer_h-w-45__kj2hA"};